"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = _interopRequireDefault(require("../styles"));
var _CardMedia = _interopRequireDefault(require("@mui/material/CardMedia"));
var _Card = require("./Card");
var _globalSpacing = require("./../globalSpacing");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _excluded = ["classes"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  root: {},
  media: {},
  img: {}
};

/**
 * CardMedia component for displaying media on a Card component
 */
var CardMedia = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = props.classes,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var spacingOptions = (0, _react.useContext)(_Card.CardContext).spacingOptions;

  // Card media needs to span across the card width
  // so using `negateSpacingRightLeft` props to set that.
  var classesOverrides = !(0, _isEmpty.default)(spacingOptions) ? (0, _globalSpacing.getSpacingStyles)({
    spacing: spacingOptions.spacing,
    negateSpacingRightLeft: true
  }, _globalSpacing.spacingType.COMPONENT_RESET) : {};
  var classOverrides = {
    root: (0, _classnames.default)(classes.root, classesOverrides),
    media: classes.media,
    img: classes.img
  };
  return /*#__PURE__*/_react.default.createElement(_CardMedia.default, (0, _extends2.default)({}, rest, {
    classes: classOverrides,
    ref: ref
  }));
});
CardMedia.muiName = 'CardMedia';
CardMedia.displayName = 'CardMedia';
CardMedia.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * Component for rendering image.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */
  image: _propTypes.default.string,
  /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */
  src: _propTypes.default.string,
  /**
   * 	The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object])
};

// If default props are needed, they must be set here
CardMedia.defaultProps = {
  component: 'div'
};
var _default = exports.default = (0, _styles.default)(styles)(CardMedia);